import { render } from "./PollAnswers.vue?vue&type=template&id=b7249154"
import script from "./PollAnswers.vue?vue&type=script&lang=js"
export * from "./PollAnswers.vue?vue&type=script&lang=js"

import exportComponent from "/working_dir/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__